import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/caret_up.svg'
import _imports_1 from '@/assets/caret_down.svg'


const _hoisted_1 = { class: "w-[220px] h-[calc(100vh-37px)] overflow-y-scroll" }
const _hoisted_2 = { class: "text-base leading-[26px] tracking-[0.01rem] uppercase font-medium text-[#51687A]" }
const _hoisted_3 = { class: "w-full flex flex-col items-start mt-2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "w-full flex items-start gap-1 cursor-pointer p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "Caret down"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: "caret up"
}
const _hoisted_8 = { class: "text-[#393840] font-medium text-sm tracking-[0.01rem] pr-1" }
const _hoisted_9 = {
  key: 0,
  class: "mt-[3px] pl-4"
}
const _hoisted_10 = ["onClick"]

import { ref } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  exampleArchive: any | null | undefined;
  selectedStepId?: number;
};

type Emits = {
  (event: "selectExampleStep", phaseId: number, stepId: number): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamplePhaseSidemenu',
  props: {
    exampleArchive: {},
    selectedStepId: {}
  },
  emits: ["selectExampleStep"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const isExamplePhaseDropdown = ref(false);
const selectedExamplePhase = ref();
const { t } = useTranslate();

const toggleExampleDropdown = (examplePhase: any) => {
  if (selectedExamplePhase.value === examplePhase) {
    isExamplePhaseDropdown.value = !isExamplePhaseDropdown.value;

    if (!isExamplePhaseDropdown.value) {
      selectedExamplePhase.value = null;
    }
  } else {
    selectedExamplePhase.value = examplePhase;
    isExamplePhaseDropdown.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.exampleArchive, (phase) => {
      return (_openBlock(), _createElementBlock("div", {
        key: phase.id,
        class: "w-full rounded-[4px] m-[2px] mt-[1px] ml-[1px] py-4 px-3 bg-[#E5E4E2]"
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_2, _toDisplayString(phase?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            onClick: ($event: any) => (toggleExampleDropdown(phase.id))
          }, [
            _createElementVNode("div", _hoisted_5, [
              (selectedExamplePhase.value === phase.id)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
              _createElementVNode("h5", _hoisted_8, _toDisplayString(_unref(t)("global.example_images")), 1)
            ])
          ], 8, _hoisted_4),
          (selectedExamplePhase.value === phase.id)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phase.steps, (step) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass(["w-full flex flex-col gap-2 p-[2px] pl-[6px] border-l-[2px] border-[#D3D1CD]", __props.selectedStepId === step.id ? 'border-[#70899c]' : '']),
                    key: step.id
                  }, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (emits('selectExampleStep', phase.id, step.id)),
                      class: _normalizeClass(["w-full relative text-sm p-[6px] rounded-primary-radius bg-transparent text-primary-text-color font-medium tracking-[0.01rem] cursor-pointer hover:bg-[#D3D1CD] duration-300", 
                __props.selectedStepId === step.id ? 'bg-white' : 'bg-transparent'
              ])
                    }, _toDisplayString(step.name), 11, _hoisted_10)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})